<template>
    <div>
      <h1>Upload CSV File</h1>
      <input type="file" @change="handleFileUpload" accept=".csv" />
    </div>
  </template>
  
  <script>
  import Papa from 'papaparse';

  export default {
    name: "Discretes",
    data() {
      return {
        file: null
      };
    },
    methods: {
      handleFileUpload(event) {
        this.file = event.target.files[0];
        if (this.file) {
          this.parseCSV();
        }
      },
      parseCSV() {
        Papa.parse(this.file, {
          complete: (result) => {
            const data = result.data;
            console.log(data); // Посмотри структуру данных в консоли
            this.sendToBackend(data);
          },
          header: true // Если заголовок в первой строке
        });
      },
      sendToBackend(data) {
        this.axios.post('api/admin/setTestDiscretes', {
            discretes: data,
        })
        .then(response => response.json())
        .then(data => {
          console.log('Success:', data);
        })
        .catch(error => {
          console.error('Error:', error);
        });
      }
    }
  }
  </script>